var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlaylistAdd = function SvgPlaylistAdd(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 8.33333H1.66602V10H11.666V8.33333ZM11.666 5H1.66602V6.66667H11.666V5ZM14.9993 11.6667V8.33333H13.3327V11.6667H9.99935V13.3333H13.3327V16.6667H14.9993V13.3333H18.3327V11.6667H14.9993ZM1.66602 13.3333H8.33268V11.6667H1.66602V13.3333Z",
    fill: "#3F3F3E"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlaylistAdd);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjY2NiA4LjMzMzMzSDEuNjY2MDJWMTBIMTEuNjY2VjguMzMzMzNaTTExLjY2NiA1SDEuNjY2MDJWNi42NjY2N0gxMS42NjZWNVpNMTQuOTk5MyAxMS42NjY3VjguMzMzMzNIMTMuMzMyN1YxMS42NjY3SDkuOTk5MzVWMTMuMzMzM0gxMy4zMzI3VjE2LjY2NjdIMTQuOTk5M1YxMy4zMzMzSDE4LjMzMjdWMTEuNjY2N0gxNC45OTkzWk0xLjY2NjAyIDEzLjMzMzNIOC4zMzI2OFYxMS42NjY3SDEuNjY2MDJWMTMuMzMzM1oiIGZpbGw9IiMzRjNGM0UiLz4KPC9zdmc+Cg==";